import { render } from "./GoldenLayoutContainer.vue?vue&type=template&id=680b6b76&ts=true"
import script from "./GoldenLayoutContainer.vue?vue&type=script&lang=ts"
export * from "./GoldenLayoutContainer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__